module.exports = __webpack_public_path__ + "static/media/sortBtn.cc104b0a.svg";